import React from 'react';

function LogoFooterIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="144"
      height="46"
      fill="none"
      viewBox="0 0 144 46"
      {...props}
    >
      <g>
        <path
          fill="#D64D00"
          d="M17.395 36.082V23.615c0-5.794-2.936-8.36-7.193-8.36-4.037 0-7.046 2.42-7.046 8.14v12.687H0V4.767h3.156v11.147c1.541-2.273 4.184-3.593 7.413-3.593 6.019 0 9.982 3.52 9.982 11.294v12.467h-3.156zm17.91.514c-7.194 0-12.405-5.207-12.405-12.321-.073-6.6 5.211-11.954 11.817-12.028h.367c6.973 0 12.037 5.134 12.037 12.174-.073 7.04-5.064 12.175-11.817 12.175zM35.01 15.18c-5.138 0-8.955 3.96-8.955 9.167 0 5.5 3.817 9.387 9.175 9.387 5.064 0 8.734-3.813 8.734-9.167 0-5.354-3.817-9.387-8.955-9.387zm45.726 20.901V22.588c0-5.207-2.349-7.48-6.165-7.48-3.67 0-6.386 2.2-6.386 7.48v13.42H65.03V22.516c0-5.207-2.716-7.334-6.312-7.334-3.89 0-6.239 2.713-6.239 7.334v13.494h-3.156V12.907h3.156v2.64c1.468-2.126 3.964-3.373 6.532-3.226 3.45 0 5.799 1.32 7.56 4.473 1.982-3.08 4.478-4.473 8.074-4.473 5.285 0 9.101 3.227 9.101 9.974v13.787h-3.009zm8.588-10.56c.367 4.693 4.33 8.287 9.027 8.213 3.523 0 6.68-2.053 8.074-5.28h3.23a12.37 12.37 0 01-11.304 8.214c-6.679.073-12.184-5.28-12.257-11.954v-.294c-.073-6.6 5.211-11.954 11.817-12.027h.22c6.9 0 12.111 4.987 12.111 13.2l-20.918-.073zm8.88-10.268c-4.403-.073-8.147 3.154-8.807 7.48h17.762c-1.027-4.693-4.477-7.553-8.954-7.48zm27.378-1.393V9.387a2.63 2.63 0 012.642-2.64h2.936V0h-2.936c-5.211 0-9.395 4.254-9.468 9.46v4.474h-5.211v6.82h5.211v14.888a2.63 2.63 0 01-2.642 2.64h-2.569v6.82h2.569c5.211 0 9.394-4.253 9.468-9.46v-14.96h9.615v17.014h6.826V13.86h-16.441zM138.648 0a4.414 4.414 0 014.403 4.4c0 2.42-1.981 4.4-4.403 4.4a4.415 4.415 0 01-4.404-4.4c0-2.42 1.981-4.4 4.404-4.4z"
        ></path>
      </g>
    </svg>
  );
}

export default LogoFooterIcon;
